import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ViewTabs from '../../../../organisms/AdvisorView/components/AdvisorViewTabs'
import { usePolicies } from '../../../../../hooks'
import GeneralTab from './GeneralTab'
import CompositionTab from './CompositionTab'
import AssignmentsTab from './AssignmentsTab'
import MetadataTab from './MetadataTab'

const tabOptions = {
  general: {
    value: 'general',
    label: 'Details'
  },
  composition: {
    value: 'composition',
    label: 'Template Composition'
  },
  metadata: {
    value: 'metadata',
    label: 'Metadata Fields'
  },
  assignments: {
    value: 'assignments',
    label: 'Assignments'
  }
}

const useTabOptions = () => {
  const policies = usePolicies()
  return useMemo(() => {
    const result = {}
    if (policies.admin_view_clients) {
      result.general = tabOptions.general
    }
    if (policies.admin_edit_status_templates) {
      result.composition = tabOptions.composition
    }
    if (policies.admin_edit_status_templates) {
      result.metadata = tabOptions.metadata
    }
    if (policies.admin_edit_status_templates) {
      result.assignments = tabOptions.assignments
    }

    return result
  }, [policies])
}

function StatusDetailTabs ({ disabled }) {
  const tabs = useTabOptions()

  return (
    <div>
      <ViewTabs.Group tabOptions={tabs}>
        <div>
          <ViewTabs.Links
            disabled={disabled}
            tabsKey='admin_status_template_details'
          />
        </div>
        {tabs.general ? (
          <ViewTabs.Tab value='general'>
            <GeneralTab />
          </ViewTabs.Tab>
        ) : null}
        {tabs.composition ? (
          <ViewTabs.Tab value='composition'>
            <CompositionTab />
          </ViewTabs.Tab>
        ) : null}
        {tabs.metadata ? (
          <ViewTabs.Tab value='metadata'>
            <MetadataTab />
          </ViewTabs.Tab>
        ) : null}
        {tabs.assignments ? (
          <ViewTabs.Tab value='assignments'>
            <AssignmentsTab />
          </ViewTabs.Tab>
        ) : null}
      </ViewTabs.Group>
    </div>
  )
}

StatusDetailTabs.propTypes = {
  disabled: PropTypes.bool
}

StatusDetailTabs.defaultProps = {
  disabled: false
}

export default StatusDetailTabs
